// assets/load-more.js
(function() {
  const grid   = document.querySelector('.collection-products');
  const button = document.getElementById('LoadMoreButton');
  if (!grid || !button) return;

  button.addEventListener('click', async () => {
    const nextUrl = button.dataset.nextUrl;
    if (!nextUrl) return;

    button.disabled   = true;
    button.textContent = 'loading...';

    try {
      // Fetch the full next page and parse out its products
      const res  = await fetch(nextUrl);
      const html = await res.text();
      const tmp  = document.createElement('div');
      tmp.innerHTML = html;

      // Append each fetched product into the grid
      tmp.querySelectorAll('.collection-products .product-list-item').forEach(item => {
        grid.appendChild(item);
      });

      // Re-initialize lazy-load for all [data-rimg="lazy"] images
      if (window.rimgApi && typeof window.rimgApi.track === 'function') {
        window.rimgApi.track();
      }
      // Check if there’s still another page
      const newBtn = tmp.querySelector('#LoadMoreButton');
      if (newBtn) {
        button.dataset.nextUrl = newBtn.dataset.nextUrl;
        button.disabled       = false;
        button.textContent    = 'Load more';
      } else {
        button.remove();
      }
    } catch (err) {
      console.error(err);
      button.disabled = false;
      button.textContent = 'Loading error';
    }
  });
})();